import React from "react";

const MenuExpandIcon = ({width, height}) => {
  return (
    <svg
      width={width || "16"}
      height={height || "17"}
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.29365 13.1363C7.68428 13.527 8.31865 13.527 8.70928 13.1363L14.7093 7.13633C15.0999 6.7457 15.0999 6.11133 14.7093 5.7207C14.3187 5.33008 13.6843 5.33008 13.2937 5.7207L7.9999 11.0145L2.70615 5.72383C2.31553 5.3332 1.68115 5.3332 1.29053 5.72383C0.899902 6.11445 0.899902 6.74883 1.29053 7.13945L7.29053 13.1395L7.29365 13.1363Z"
        fill="#595959"
      />
    </svg>
  );
};

export default MenuExpandIcon;